import React from 'react';
import {
  Container,
  Col,
  Input,
  Card,
  CardBody,
  FormGroup,
  Label,
  Form,
  Button
} from 'reactstrap';
import { AUTH_URL, IS_DEVELOPMENT } from '../services/config';
import { getTokenExpiresAt } from '../services/json-web-token';
import { Emitter as AuthenticationEmitter } from '../services/authentication';

class Login extends React.Component {

  state = {
    username: '',
    password: '',
    loading: false,
    message: null
  };

  componentDidMount() {
    AuthenticationEmitter.emit('unauthenticated');
  }

  onFieldChange = (event) => {
    this.setState({
      [event.target.name]: event.target.type === 'checkbox' ? event.target.checked : event.target.value
    });
  };

  getField(name, valueProp = 'value', defaultValue = '') {
    return {
      name,
      id: name,
      [valueProp]: this.state[name] || defaultValue,
      onChange: this.onFieldChange,
      disabled: this.state.loading
    }
  }

  isValid() {
    return (
      this.state.username &&
      this.state.password
    )
  }

  onSubmit = async (event) => {
    event.preventDefault();
    if (!this.isValid()) {
      return null;
    }
    if (this.state.loading || this.internalLoading) {
      return null;
    }
    this.internalLoading = true;
    await new Promise(resolve => this.setState({
      loading: true,
      message: null
    }, resolve));
    this.internalLoading = false;
    try {
      const response = await fetch(
        AUTH_URL,
        {
          method: 'POST',
          body: JSON.stringify({
            userName: this.state.username,
            password: this.state.password
          }),
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        }
      );
      const result = await response.json();
      if (!result.token) {
        throw new Error('Invalid username or password');
      }
      this.props.onAuthenticated(result.token, getTokenExpiresAt(result.token));
    } catch(e) {
      this.setState({
        message: e.message,
        loading: false
      });
    }
  };

  render() {
    return (
      <div style={{ minHeight: '100vh', minWidth: '100vw', ...(IS_DEVELOPMENT ? { backgroundColor: 'rgba(255, 192, 203, 0.2)' } : {})}}>
        <Container>
          <Col className="d-flex flex-row justify-content-center align-items-center p-5" style={{minHeight: '80vh'}}>
            <Card style={{ minWidth: 450, borderWidth: '1px', borderColor: 'rgb(240, 240, 240)', borderRadius: 3, boxShadow: '2px 2px 9px -4px rgba(0,0,0,0.75)' }}>
              <CardBody>
                <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginBottom: 45 }} >
                  <img src="/assets/images/rewards-logo-color.png" style={{ height: 100, objectFit: 'contain', objectPosition: 'center' }} />
                </div>
                {
                  this.state.message ? (
                      <p style={{ color: 'red' }}>{this.state.message}</p>
                  ) : null
                }
                <Form onSubmit={this.onSubmit}>
                  <FormGroup row>
                    <Label for="username" sm={3}>Username</Label>
                    <Col sm={9}>
                      <Input {...this.getField('username')} type="text" placeholder="Username" />
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Label for="password" sm={3}>Password</Label>
                    <Col sm={9}>
                      <Input {...this.getField('password')} type="password" placeholder="Password" />
                    </Col>
                  </FormGroup>
                  <FormGroup check row>
                    <Col sm={{ size: 9, offset: 3 }} className="p-0">
                      <Button disabled={this.state.loading || !this.isValid()}>Submit</Button>
                    </Col>
                  </FormGroup>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Container>
      </div>
    )
  }

}

export default Login;



// WEBPACK FOOTER //
// ./src/app/login.js